<template>
  <div class="card m-t-20">
    <div class="card-body p-0">
      <cardHead :title="'CreateScanItems'"></cardHead>
      <dataTable :name="'CreateScanItems'" ref="agGrid" :data="data" :columnDefs="columnDefs.main" @cellClicked="detail=$event.data" @scans="scans($event)"></dataTable>
        <!-- <pre>{{data}}</pre> -->
        <modal size="xl" v-show="detail!=null" @close="detail=null">
            <template #content>
                <div class="modal-header align-items-center">
                    <h4 class="modal-title col">Detail</h4>
                    <Btn class="btn-success btn-sm m-r-10" @click="copy(JSON.stringify(detail))">Copy</Btn>
                    <Btn class="btn-success btn-sm" @click="scans(detail)">Scan</Btn>
                </div>
                <pre class="m-0">{{detail}}</pre>
            </template>
            <template #foot>
                <Btn class="btn-success btn-md" @click="scans(detail)">Scan</Btn>
            </template>
        </modal>
        <modal size="xl" v-show="scanOpen" @close="scanOpen=false">
            <template #content>
                <div class="modal-header align-items-center">
                    <h4 class="modal-title">Scan</h4>
                    <Btn class="btn-success btn-sm" @click="copy(JSON.stringify(scan))">Copy</Btn>
                </div>
                <ul class="nav nav-tabs profile-tab border-bottom" v-if="scan!=null">
                    <li class="nav-item">
                        <a href="javascript:;" class="nav-link" :class="{'active':tab=='JSON'}" @click="tab='JSON'">JSON</a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:;" class="nav-link" :class="{'active':tab=='Prices'}" @click="tab='Prices'">Prices</a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:;" class="nav-link" :class="{'active':tab=='MinPrices'}" @click="tab='MinPrices'">MinPrices</a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:;" class="nav-link" :class="{'active':tab=='Hotels'}" @click="tab='Hotels'">Hotels</a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:;" class="nav-link" :class="{'active':tab=='DBLCHDMinPrices'}" @click="tab='DBLCHDMinPrices'">DBLCHDMinPrices</a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:;" class="nav-link" :class="{'active':tab=='DBLCHDPrices'}" @click="tab='DBLCHDPrices'">DBLCHDPrices</a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:;" class="nav-link" :class="{'active':tab=='DBLMinPrices'}" @click="tab='DBLMinPrices'">DBLMinPrices</a>
                    </li>
                    <li class="nav-item">
                        <a href="javascript:;" class="nav-link" :class="{'active':tab=='DBLPrices'}" @click="tab='DBLPrices'">DBLPrices</a>
                    </li>
                </ul>
                <load-area v-if="scan==null"></load-area>
                <pre class="m-0" v-if="scan!=null && tab=='JSON'">{{getScanJson}}</pre>
                <dataTable v-if="scan!=null && tab=='DBLCHDMinPrices'" :name="'DBLCHDMinPrices'" :columnDefs="columnDefs.DBLCHDMinPrices" ref="agGrid" :data="scan.DBLCHDMinPrices"></dataTable>
                <dataTable v-if="scan!=null && tab=='DBLCHDPrices'" :name="'DBLCHDPrices'" ref="agGrid" :columnDefs="columnDefs.default" :data="getSetArray('DBLCHDPrices')"></dataTable>
                <dataTable v-if="scan!=null && tab=='DBLMinPrices'" :name="'DBLMinPrices'" ref="agGrid" :columnDefs="columnDefs.DBLCHDMinPrices" :data="scan.DBLMinPrices"></dataTable>
                <dataTable v-if="scan!=null && tab=='DBLPrices'" :name="'DBLPrices'" ref="agGrid" :columnDefs="columnDefs.default" :data="getSetArray('DBLPrices')"></dataTable>
                <dataTable v-if="scan!=null && tab=='Hotels'" :name="'Hotels'" ref="agGrid" :columnDefs="columnDefs.hotels" :data="scan.Hotels"></dataTable>
                <dataTable v-if="scan!=null && tab=='MinPrices'" :name="'MinPrices'" ref="agGrid" :columnDefs="columnDefs.prices" :data="scan.MinPrices"></dataTable>
                <dataTable v-if="scan!=null && tab=='Prices'" :name="'Prices'" ref="agGrid" :columnDefs="columnDefs.prices" :data="scan.Prices"></dataTable>
            </template>
        </modal>
    </div>
  </div>
</template>

<script>
    import moment from 'moment';
    export default {
        name:"CreateScanItems",
        props:{
            model:Object,
            open:Number
        },
        data(){
            return{
                data:null,
                tab:"JSON",
                columnDefs:{
                    main:[
                        {"headerName":"Retry","field":"Retry","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"ReportKey","field":"ReportKey","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"ConnectionId","field":"ConnectionId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Operator","field":"Operator","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return params.value?.Name
                            }
                        },
                        {"headerName":"Duration","field":"Duration","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"StartDate","field":"StartDate","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return moment(new Date(params.value)).format('DD.MM.YYYY')
                            }
                        },
                        {"headerName":"EndDate","field":"EndDate","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return moment(new Date(params.value)).format('DD.MM.YYYY')
                            }
                        },
                        {"headerName":"DepartureCountry","field":"DepartureCountry","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return params.value?.Name
                            }
                        },
                        {"headerName":"DepartureCity","field":"DepartureCity","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return params.value?.Name
                            }
                        },
                        {"headerName":"DestinationCountry","field":"DestinationCountry","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return params.value?.Name
                            }
                        },
                        {"headerName":"DestinationPlace","field":"DestinationPlace","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Hotel Count","field":"Hotels","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return params.value.length
                            }
                        },
                        {"headerName":"Adult","field":"Adult","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Childs","field":"Childs","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {
                            headerName: "",
                            type:"action",
                            width:45,
                            buttons:[
                                {
                                classes:"btn btn-xs waves-effect waves-light btn-success",
                                text:'Scan',
                                    emit:"scans"
                                },
                            ],
                            filter:false,
                            sortable:false,
                            resizable: false,
                            floatingFilter: false,
                            cellRenderer: this.$BtnCellRenderer,
                            cellRendererParams: {
                                clicked: function(field) {
                                this.$emit(field.emit,field.data)
                                }
                            }
                            }
                    ],
                    default:[
                        {"headerName":"PriceKey","field":"PriceKey","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Key","field":"key","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"OperatorId","field":"OperatorId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"HotelId","field":"HotelId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"DepartureCityId","field":"DepartureCityId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"OperatorHotelCode","field":"OperatorHotelCode","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"HotelName","field":"HotelName","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Checkin","field":"Checkin","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return moment(new Date(params.value)).format('DD.MM.YYYY')
                            }
                        },
                        {"headerName":"Duration","field":"Duration","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Room","field":"Room","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Meal","field":"Meal","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Price","field":"Price","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"CurrencyCode","field":"CurrencyCode","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"LastUpdate","field":"LastUpdate","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return moment(new Date(params.value)).format('DD.MM.YYYY hh:mm:ss')
                            }
                        }
                    ],
                    DBLCHDMinPrices:[
                        {"headerName":"PriceKey","field":"PriceKey","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"OperatorId","field":"OperatorId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"HotelId","field":"HotelId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"DepartureCityId","field":"DepartureCityId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"OperatorHotelCode","field":"OperatorHotelCode","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"HotelName","field":"HotelName","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Checkin","field":"Checkin","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            cellRenderer: function (params) {
                                console.log("Checkin",params);
                                return moment(new Date(params.value)).format('DD.MM.YYYY')
                            }
                        },
                        {"headerName":"Duration","field":"Duration","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Room","field":"Room","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Meal","field":"Meal","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Price","field":"Price","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"CurrencyCode","field":"CurrencyCode","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"LastUpdate","field":"LastUpdate","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return moment(new Date(params.value)).format('DD.MM.YYYY hh:mm:ss')
                            }
                        }
                    ],
                    hotels:[
                        {"headerName":"HotelId","field":"HotelId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"OperatorHotelCode","field":"OperatorHotelCode","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"OperatorHotelName","field":"OperatorHotelName","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                    ],
                    prices:[
                        {"headerName":"PriceKey","field":"PriceKey","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"OperatorId","field":"OperatorId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"IsLocalOperator","field":"IsLocalOperator","enableRowGroup":true,"floatingFilter":false,"filter":false,"flex":1,"cellClick":true,"minWidth":140,"cellRenderer":this.$CheckCellRenderer},
                        {"headerName":"DepartureCityId","field":"DepartureCityId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"HotelId","field":"HotelId","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"OperatorHotelCode","field":"OperatorHotelCode","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"HotelName","field":"HotelName","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Checkin","field":"Checkin","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return moment(new Date(params.value)).format('DD.MM.YYYY')
                            }
                        },
                        {"headerName":"Duration","field":"Duration","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"DBLRoom","field":"DBLRoom","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"DBLMeal","field":"DBLMeal","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"DBLCHDRoom","field":"DBLCHDRoom","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"DBLCHDMeal","field":"DBLCHDMeal","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"PackageRoom","field":"PackageRoom","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"PackageMeal","field":"PackageMeal","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"PP","field":"PP","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"DBL","field":"DBL","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"DBLCHD","field":"DBLCHD","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Flight","field":"Flight","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Package","field":"Package","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"Daily","field":"Daily","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"CurrencyCode","field":"CurrencyCode","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140},
                        {"headerName":"LastUpdate","field":"LastUpdate","enableRowGroup":true,"floatingFilter":true,"filter":"agTextColumnFilter","flex":1,"cellClick":true,"minWidth":140,
                            valueFormatter:function(params){
                                return moment(new Date(params.value)).format('DD.MM.YYYY hh:mm:ss')
                            }
                        }
                    ]
                },
                detail:null,
                scan:null,
                scanOpen:false
            }
        },
        watch:{
            open(){
                this.get();
            }
        },
        created(){
            this.get();
        },
        methods:{
            get(){
                this.data=null;
                this.$appAxiosTourscope.post(`Helpers/CreateScanItems`,this.model).then(response=>{
                    // this.openReport=response.data;
                    console.log("CreateScanItems",response);
                    this.data=response.data;
                    this.processCreateScanItems=false;
                })
            },
            scans(item){
                this.scan=null;
                this.scanOpen=true;
                this.$appAxiosTourscope.post(`Helpers/Scan`,item).then(response=>{
                    this.scan=response.data;
                })
            },
            copy(value){
                navigator.clipboard.writeText(value);
            },
            getSetArray(column){
                var data=[];
                Object.entries(this.scan[column]).forEach(element => {
                    data.push({...element[1],key:element[0]});
                });
                return data;
            }
        },
        computed:{
            getScanJson(){
                var data={...this.scan};
                delete data.DBLCHDMinPrices;
                delete data.DBLCHDPrices;
                delete data.DBLMinPrices;
                delete data.DBLPrices;
                delete data.Hotels;
                delete data.MinPrices;
                delete data.Prices;
                return data;
            }
        }
    }
</script>

<style>

</style>